import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isOpen: false,
  title: "",
  maxWidth: "sm", // xs, sm, md, lg, xl
  fullWidth: false,
  fullScreen: false,
  children: null,
  actions: null,
  // Agregar un identificador para el tipo de contenido
  contentType: null,
  contentProps: null,
};

export const modalSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    openModal: (state, action) => {
      const {
        title,
        maxWidth,
        fullWidth,
        fullScreen,
        contentType,
        contentProps,
      } = action.payload || {};
      state.isOpen = true;
      state.title = title || "";
      state.maxWidth = maxWidth || "sm";
      state.fullWidth = fullWidth || false;
      state.fullScreen = fullScreen || false;
      state.contentType = contentType || null;
      state.contentProps = contentProps || null;
    },
    closeModal: (state) => {
      state.isOpen = false;
      state.title = "";
      state.maxWidth = "sm";
      state.fullWidth = false;
      state.fullScreen = false;
      state.contentType = null;
      state.contentProps = null;
      state.children = null;
      state.actions = null;
    },
    setModalTitle: (state, action) => {
      state.title = action.payload;
    },
    setModalSize: (state, action) => {
      const { maxWidth, fullWidth, fullScreen } = action.payload;
      if (maxWidth) state.maxWidth = maxWidth;
      if (fullWidth !== undefined) state.fullWidth = fullWidth;
      if (fullScreen !== undefined) state.fullScreen = fullScreen;
    },
    setModalContent: (state, action) => {
      const { children, actions } = action.payload;
      if (children !== undefined) state.children = children;
      if (actions !== undefined) state.actions = actions;
    },
  },
});

export const {
  isOpen,
  openModal,
  closeModal,
  setModalTitle,
  setModalSize,
  setModalContent,
} = modalSlice.actions;

export default modalSlice.reducer;
